(() => {
  if (window.iStoreContactPageLoaded) return;
  window.iStoreContactPageLoaded = true;

  const mobileMedia = window.matchMedia("(max-width: 749px)");
  const reducedMotionMedia = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  );

  const setupSlider = (slider) => {
    if (slider.dataset.iStoreSliderReady === "true") return;

    const viewport = slider.querySelector("[data-istore-slider-viewport]");
    const track = slider.querySelector("[data-istore-slider-track]");
    const items = [...slider.querySelectorAll("[data-istore-slider-item]")];
    const dots = [...slider.querySelectorAll("[data-istore-slider-page]")];
    const previousButtons = [
      ...slider.querySelectorAll("[data-istore-slider-previous]"),
    ];
    const nextButtons = [
      ...slider.querySelectorAll("[data-istore-slider-next]"),
    ];
    const controls = [
      ...slider.querySelectorAll("[data-istore-slider-controls]"),
    ];

    if (!viewport || !track || items.length === 0) return;

    slider.dataset.iStoreSliderReady = "true";

    const getItemsPerPage = () =>
      Number(
        mobileMedia.matches
          ? slider.dataset.itemsMobile
          : slider.dataset.itemsDesktop,
      ) || 1;

    const getStep = () => {
      const gap =
        Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return (items[0].getBoundingClientRect().width + gap) * getItemsPerPage();
    };

    const getMaximumPage = () =>
      Math.max(0, Math.ceil(items.length / getItemsPerPage()) - 1);

    const getCurrentPage = () => {
      const step = getStep();
      return step > 0
        ? Math.min(getMaximumPage(), Math.round(viewport.scrollLeft / step))
        : 0;
    };

    const updateControls = () => {
      const maximumPage = getMaximumPage();
      const currentPage = getCurrentPage();
      const hasPages = maximumPage > 0;

      controls.forEach((control) => {
        control.hidden = !hasPages;
      });
      previousButtons.forEach((button) => {
        button.disabled = !hasPages || currentPage === 0;
      });
      nextButtons.forEach((button) => {
        button.disabled = !hasPages || currentPage === maximumPage;
      });
      dots.forEach((dot, index) => {
        const isCurrent = index === currentPage;
        dot.classList.toggle("is-active", isCurrent);
        if (isCurrent) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
        dot.hidden = index > maximumPage;
      });
    };

    const goToPage = (page) => {
      const targetPage = Math.max(0, Math.min(getMaximumPage(), page));
      viewport.scrollTo({
        left: getStep() * targetPage,
        behavior: reducedMotionMedia.matches ? "auto" : "smooth",
      });
    };

    previousButtons.forEach((button) => {
      button.addEventListener("click", () => goToPage(getCurrentPage() - 1));
    });
    nextButtons.forEach((button) => {
      button.addEventListener("click", () => goToPage(getCurrentPage() + 1));
    });
    dots.forEach((dot) => {
      dot.addEventListener("click", () =>
        goToPage(Number(dot.dataset.iStoreSliderPage)),
      );
    });

    let animationFrame;
    viewport.addEventListener(
      "scroll",
      () => {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(updateControls);
      },
      { passive: true },
    );

    if ("ResizeObserver" in window) {
      new ResizeObserver(updateControls).observe(viewport);
    } else {
      window.addEventListener("resize", updateControls, { passive: true });
    }

    updateControls();
  };

  const setupSliders = (scope = document) => {
    scope.querySelectorAll("[data-istore-slider]").forEach(setupSlider);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupSliders(), {
      once: true,
    });
  } else {
    setupSliders();
  }

  document.addEventListener("shopify:section:load", (event) =>
    setupSliders(event.target),
  );
})();
